import * as React from 'react';
import formContext from '@formily/react/lib/context';
import { get } from 'lodash';
export const useFormInstance = () => {
  const form = React.useContext(formContext); // todo 这里有些问题，设置过一次，有可能会一直生效

  const reSetFormValue = React.useCallback(data => {
    form.setFieldState('*', s => {
      const val = get(data, s.name);
      s.value = val;
    });
    /** 这里如果data里有form没用到的项目，那么上面的修改是不生效的 */

    form.setFormState(s => {
      s.values = data;
    });
  }, [form]);

  if (!form) {
    return form;
  }

  return Object.assign(form, {
    /** 设置整个form的值 */
    reSetFormValue
  });
};
//# sourceMappingURL=es/hooks/useFormInstance.js.map